import React, { Component } from "react"
import Menu, { NestedDropdownMenu } from "react-dd-menu"

import { LAYOUT } from "../../modules/constants"

import {
  Button,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material'

import MenuRoundedIcon from '@mui/icons-material/MenuRounded'

//#region  modules
import { COLOR, PATH } from "../../modules/constants"
import { todaysTrialCode, getUrlTrialDaysLeft } from "../../modules/trialCode"
//#endregion module

export class HamburgerMenu extends Component {

  state = {
    isMenuOpen: false
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }

  close() {
    if (this.refs.myRef && this.state.isMenuOpen) {
      this.setState({ isMenuOpen: false })
    }
  }

  login() {
    this.setState({ isMenuOpen: false }, () => this.props.login())
  }

  logout() {
    this.setState({ isMenuOpen: false }, () => this.props.logout())
  }

  disconnect() {
    this.setState({ isMenuOpen: false }, () => this.props.disconnect())
  }

  renderButton() {
    return (
      <Tooltip title="menu">
        <IconButton
          aria-label="open menu"
          data-intro="click to open menu"
          onClick={() => this.toggle()}
          sx={{ marginRight: `${LAYOUT.COLUMN_PADDING - 6}px`, color: COLOR.NAVBAR_TEXT }}
        >
          <MenuRoundedIcon />
        </IconButton>
      </Tooltip>
    )
  }

  getExclusionState = () => window.localStorage.plausible_ignore === "true"

  toggleTracking() {
    const exclusionState = this.getExclusionState()

    if (exclusionState) {
      delete window.localStorage.plausible_ignore
      console.log("prevent tracking cookie deleted")
    } else {
      window.localStorage.plausible_ignore = "true"
      console.log("prevent tracking cookie set")
    }
  }

  // Show today's trial code
  trialCode() {
    const trialCode = todaysTrialCode()
    // console.log("trial code: " + trialCode)

    // Get the number of days left in the trial -
    const daysLeft = getUrlTrialDaysLeft(trialCode)
    console.log("trial code daysLeft: ", daysLeft)
  }

  render() {
    const {
      classes,
      the350club,
    } = this.props

    // Added color to warn user in they are not on 'localhost'
    const debugButtonProps = {
      // By default, const debugButtonProps = { … } is inferred as a plain object with
      // variant: string, not "menu". That makes variant incompatible with ButtonProps['variant'].
      // So we have to help TypeScript by annotating variant as "menu".
      // See https://mui.com/material-ui/api/button/#props
      // variant: "menu",
      // sx: { color: location.hostname !== "localhost2" ? COLOR.BAD : COLOR.BLACK },
    }

    // Added color to warn user in they are not on 'localhost'
    const buttonStyle = { color: location.hostname !== "localhost" ? COLOR.BAD : COLOR.BLACK }

    // Helper function to push history
    const historyPush = pathname => this.props.common.selectRow({ ...this.props, pathname })

    return (
      <Menu ref="myRef" isOpen={this.state.isMenuOpen} toggle={this.renderButton()} close={() => this.close()} align="right" >
        <li><Button variant="menu" onClick={() => historyPush(`/${PATH.ABOUT}`)}>About Numerable</Button></li>

        <li style={{ listStyle: "none" }}><Button variant="menu" onClick={() => historyPush(`/${PATH.BOOKMARKING}`)}>How to Add a Bookmark</Button></li>

        <li><Button variant="menu" onClick={() => historyPush(`/${PATH.PRIVACY}`)}>Privacy Policy</Button></li>

        <li><a href={the350club
          ? "https://www.numerable.io/?utm_source=350club&utm_medium=numapp&utm_campaign=menu"
          : "https://www.numerable.io/?utm_source=numerable&utm_medium=numapp&utm_campaign=menu"}
          target="_blank" rel="noopener noreferrer" >Visit Numerable website</a></li>
      </Menu>
    )
  }
}
